import { Component, Input, OnInit } from '@angular/core';
import { TravelReport } from 'src/app/client-management/parc-management';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
const Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);

@Component({
  selector: 'app-classification-rotation-chart',
  templateUrl: './classification-rotation-chart.component.html',
  styleUrls: ['./classification-rotation-chart.component.scss']
})
export class ClassificationRotationChartComponent implements OnInit {

  classments: TravelReport[] = [];
  classmentObject: Object | null = null;

  @Input()
  set rotations(rotations: TravelReport[]) {
    if (rotations) {
      this.classments = Object.assign(rotations);
        this.classmentChart();
      }
  }

  constructor(private chartConfig : ChartConfigService) { }

  ngOnInit() {
      this.classmentChart();

  }


  classmentChart() {
    this.chartConfig.setHighCartsLang();

    var seriesData = [];

    for (let classment of this.classments) {
      seriesData.push([classment.vehiculeMatricule, classment.rotation])
    }

    this.classmentObject = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Rotation',
        align: 'center',
        style: {
          fontWeight: 'bold'
        }
      },
      xAxis: {
        type: 'category',

        labels: {
          rotation: -45,
          style: {
            color: "#000000",
            fontWeight: 'bold',
            textDecoration: "underline"
          }
        }
      },
      yAxis: {
        title: {
          text: 'Σ.Rotation'
        },
        labels: {
          enabled: false
        }
      },
      legend: {
        enabled: false
      },
      accessibility: {
        point: {
          valueSuffix: 'Σ.Rotation'
        }
      }, credits: {
        enabled: false
      },
      tooltip: {
        pointFormat: '<b>{point.y:.2f} Rotation</b>'
      },
      plotOptions: {
        column: {
          borderRadius: 5
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y:.2f} '
          }
        }
      },
      series: [{
        colorByPoint: true,
        data: seriesData
      }]
    }
    Highcharts.chart('classmentRotationObject', this.classmentObject);
  }

}
